module.exports = __webpack_public_path__ + "img/cobbl2.72d94407.jpeg";